module.exports = __webpack_public_path__ + "static/media/icon_qr_code.f5e0ba28.svg";